export type ZoomVideoSdkLiveTranscriptionLanguageType = {
  /**
   * language id of transcription language
   */
  languageId: number;

  /**
   * localized language name of transcription language
   */
  languageName: string;
};

export class ZoomVideoSdkLiveTranscriptionLanguage
  implements ZoomVideoSdkLiveTranscriptionLanguageType
{
  languageId;
  languageName;

  constructor(language: ZoomVideoSdkLiveTranscriptionLanguageType) {
    this.languageName = language.languageName;
    this.languageId = language.languageId;
  }
}
